import { observer } from "mobx-react";
import { APIClient } from "network-stapler";
import React from "react";
import { Link } from "react-router-dom";
import LoadingIndicatorWrapper from "../Components/LoadingIndicatorWrapper";
import SalesPartnerItem from "../Components/SalesPartnerItem";
import StepsNavigation from "../Components/StepsNavigation";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";
import { IZipZone } from "../Utils/Interface";
import "./SalesPartnerPage.css";

type Props = {
	langLocal: string;
	apiClientDynamicBaseUrl: APIClient;
};

type State = {
	pageIsActive: number;
};

@observer
class SalesPartnerPage extends React.Component<Props, State> {

	constructor(props: Props) {
		super(props);
		// set initial state
		this.state = {
			pageIsActive: 3,
		};
	}

	componentDidMount() {
		store.loadZipData(this.props.apiClientDynamicBaseUrl, this.props.langLocal);
	}

	handleSelect = (e: any) => {
		var count: any = {};

		store.zipZonesStore?.zones?.forEach((zone: IZipZone) => {
			if (zone.regionName) count[zone.regionName] = (count[zone.regionName] || 0) + 1;
		});

		var zipCodeCount = e.target.options[e.target.selectedIndex].dataset.zip;

		store.zipZonesStore?.toggleZipZoneSelection(e.target.value, count[e.target.value], zipCodeCount);
	};

	handleZipInput = (e: any) => {
		store.zipZonesStore?.toggleZipInput(e.target.value);
	};

	getCountryNames() {
		var countryNames: IZipZone[] = [];

		// add country name to array if not exist in array already
		store.zipZonesStore?.zones?.forEach((zone: IZipZone) => {
			if (!countryNames.some((x) => x.regionName === zone.regionName)) {
				countryNames.push(zone);
			}
		});

		return countryNames;
	}

	render() {
		const selectedModulesCounter = store.productConfigurationStore?.formattedNumberOfSelectedModules;
		const zoneNames = this.getCountryNames();
		const selectedPartner = store.zipZonesStore?.selectedPartner;
		const selectedRegion = store.zipZonesStore?.selectedRegion;
		const showZipInputField = store.zipZonesStore?.showZipInputField;
		const zipCodeCount = store.zipZonesStore?.zipCodeCount;

		return (
			<div className="sales-partner-page dark">
				{store.productConfigurationStore?.isLoading ? (
					<LoadingIndicatorWrapper />
				) : (
						<>
							<StepsNavigation
								pageIsActive={this.state.pageIsActive}
								sublineStep1={selectedModulesCounter}
								sublineStep2={store.configs?.sublineSummary}
							/>
							<div className="container zip-container">
								<div className="row">
									<div className="col-lg-8">
										<div className="zip-content-wrapper">
											<h1>{store.configs?.salesPartnerHeadline}</h1>
											<p className="light-paragraph">{store.configs?.salesPartnerText}</p>
											<select
												className={`single-select form-control form-control-lg `}
												onChange={this.handleSelect}
												required={true}
												value={selectedRegion ? selectedRegion : ""}
											>
												<option value="undefined" data-zip="undefined">{store.configs?.generalSelectFieldPlaceholder}</option>
												{zoneNames !== undefined &&
													zoneNames.map((zone: IZipZone) => {
														if (!zone.isHeadquarter && zone.regionName) {
															return (
																<option key={`${zone.salesPartnerId}`} value={zone.regionName} data-zip={zone.zipCodeCount}>
																	{zone.regionName}
																</option>
															);
														} else {
															return false;
														}
													})}
											</select>
											<div className={`zip-input-wrapper ${showZipInputField ? "d-block" : "d-none"}`}>
												{selectedRegion &&
													<>
														<input
															type="text"
															placeholder={`${store.configs?.salesPartnerZipPlaceholder} (${zipCodeCount} ${store.configs?.salesPartnerZipPlaceholderNumerals})`}
															className={`zip-input`}
															onChange={this.handleZipInput}
															maxLength={zipCodeCount}
														/>
														<span className="zip-input-icon"></span>
													</>
												}	
											</div>
											<Link className={`btn btn-primary`} to={selectedPartner ? "/submit" : "/sales-partner"}>
												{store.configs?.salesPartnerCtaButtonText}
											</Link>
										</div>
									</div>
									<div className="col-lg-4 d-flex align-items-center">
										{store.zipZonesStore?.selectedPartner && <SalesPartnerItem partner={store.zipZonesStore?.selectedPartner} />}
									</div>
								</div>
							</div>
						</>
					)}
			</div>
		);
	}
}

export default SalesPartnerPage;
